import {
  EmployeeType,
  EmploymentType,
  LegalEntityType,
} from '@omnipresentgroup/types';

export const EMPLOYMENT_LEGAL_ENTITY_TYPES_MAPPING = {
  [EmploymentType.EOR]: [
    LegalEntityType.EMPLOYER_OF_RECORD,
    LegalEntityType.CONSULTING_ENTITY,
  ],
  [EmploymentType.PEO]: [LegalEntityType.PROFESSIONAL_EMPLOYMENT_ORGANISATION],
  [EmploymentType.VIRTUAL_EMPLOYER]: [LegalEntityType.VIRTUAL_EMPLOYER],
};

export const EMPLOYEE_EMPLOYMENT_TYPE_MAPPING = {
  [EmployeeType.EOR]: EmploymentType.EOR,
  [EmployeeType.PEO]: EmploymentType.PEO,
  [EmployeeType.VIRTUAL_EMPLOYER]: EmploymentType.VIRTUAL_EMPLOYER,
  [EmployeeType.CONTRACTOR]: undefined, // for typing, as we won't get in this case
};
